<template>
    <div class="absolute pin-r mr-md" style="top: calc(50% - 8px)">
        <span
            ref="button"
            @mouseenter="show = true"
            @mouseleave="show = false"
        >
            <font-awesome-icon icon="info-circle" class="text-neutral-dark" />
        </span>

        <div
            v-if="show === true"
            ref="infobox"
            class="alert rounded font-normal text-sm border-neutral-dark absolute border-l-sm m-xl"
            style="min-width: 328px"
        >
            <slot />
        </div>
    </div>
</template>

<script>
    import Popper from 'popper.js';

    export default {
        data() {
            return {
                show: false,
            };
        },
        watch: {
            show(shouldShow) {
                if (shouldShow) {
                    this.$nextTick(() => {
                        this.setupPopper();
                    });
                }
            },
        },
        methods: {
            setupPopper() {
                this.popper = new Popper(this.$refs.button, this.$refs.infobox);
            },
        },
    };
</script>
